import { logError } from '@databases/logs';
import { addChangeToDraft } from '@databases/redux/changesets/actions';
import { currentSnackbarState } from '@databases/snackbar/snackbar';
import { Database } from '@databases/types/database';
import { DatabaseChangeType } from '@databases/types/redux';
import { createEntry } from '@databases/utils/database/utils';
import { selectCollabManagerByContentId } from '@databases/utils/redux/collab/selectors';

export const handleCreateEntry = async (
  selectedDatabase: Database,
  dispatch: any,
  store: any
) => {
  return new Promise((resolve) => {
    let isAddEntryPending = false;
    const entry = createEntry(selectedDatabase);
    const collabManager = selectCollabManagerByContentId(store.getState(), {
      contentId: selectedDatabase.contentId,
    });

    if (collabManager) {
      collabManager.onPendingChanges((pending: boolean) => {
        if (isAddEntryPending && !pending) {
          resolve(entry.id);
        }
      });
    } else {
      const error = new Error('Could not select collab manager for entry creation');
      currentSnackbarState.setMessage(error.message, {
        showCloseButton: true,
      });
      logError(error);
      resolve(undefined);
    }
    dispatch(
      addChangeToDraft(selectedDatabase.contentId, 'main', {
        type: DatabaseChangeType.ADD_ENTRY,
        entry,
      })
    );
    isAddEntryPending = true;
  });
};
